import { render } from "./VDateField.vue?vue&type=template&id=4b7e20f0&ts=true"
import script from "./VDateField.vue?vue&type=script&lang=ts"
export * from "./VDateField.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../deps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__